import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@shared/base';
import { NotificationType, UserNotificationItem, UserNotificationStatus } from '@shared/models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NotificationsApiService extends BaseApiService {
  private apiBaseUrl = this.microserviceApiUrl('notification');

  constructor(private http: HttpClient) {
    super();
  }

  public subscribe(countryCode: string): Observable<unknown> {
    return this.http.post(
      `${this.apiBaseUrl}/notifications/subscribe`,
      {},
      { params: { countryCode }, headers: { omitLoader: 'true' } }
    );
  }

  public poll(countryCode: string, types: NotificationType[]): Observable<UserNotificationItem[]> {
    return this.http.get<UserNotificationItem[]>(`${this.apiBaseUrl}/notifications/poll`, {
      params: { countryCode, types: types.join(',') },
      headers: { omitLoader: 'true' }
    });
  }

  public getList(
    countryCode: string,
    types: NotificationType[],
    statuses: UserNotificationStatus[],
    omitLoader = false
  ): Observable<UserNotificationItem[]> {
    return this.http.get<UserNotificationItem[]>(`${this.apiBaseUrl}/notifications`, {
      params: {
        countryCode,
        types: types.join(','),
        statuses: statuses.join(',')
      },
      headers: { omitLoader: omitLoader.toString() }
    });
  }

  public hideBulk(notificationIds: string[], omitLoader = false): Observable<unknown> {
    return this.http.put(
      `${this.apiBaseUrl}/notifications/status`,
      { notificationIds, status: UserNotificationStatus.Hidden },
      { headers: { omitLoader: omitLoader.toString() } }
    );
  }

  public dismissBulk(notificationIds: string[], omitLoader = false): Observable<unknown> {
    return this.http.put(
      `${this.apiBaseUrl}/notifications/status`,
      { notificationIds, status: UserNotificationStatus.Dismiss },
      { headers: { omitLoader: omitLoader.toString() } }
    );
  }
}
